import React from 'react';

const LoadIcon = () =>{
  return (<><span className="text-center loading loading-spinner loading-lg"></span></>);
}
export default LoadIcon;